var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C26.8629 120 -7.62939e-06 93.1371 -7.62939e-06 60C-7.62939e-06 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60C120 93.1371 93.1371 120 60 120Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3779 93.3541C48.7508 93.3541 46.1239 92.2282 44.6226 89.9766L23.6064 62.9555C20.604 59.2026 21.3548 53.9486 25.1076 50.9461C28.8605 47.9437 34.1145 48.6945 37.117 52.4474L51.3779 70.8367L82.9027 29.9297C85.9051 26.1769 91.1591 25.4261 94.912 28.4285C98.6648 31.4309 99.4156 36.685 96.4132 40.4378L58.1332 89.9764C56.2569 91.8531 54.0051 93.3541 51.3779 93.3541Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSuccess);
export default __webpack_public_path__ + "static/media/icons-success.db06766b0a30de80c9bcf8926551cd72.svg";
export { ForwardRef as ReactComponent };